import { render, staticRenderFns } from "./content-statistics.vue?vue&type=template&id=267d5010&scoped=true&"
import script from "./content-statistics.vue?vue&type=script&lang=js&"
export * from "./content-statistics.vue?vue&type=script&lang=js&"
import style0 from "./content-statistics.vue?vue&type=style&index=0&id=267d5010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d5010",
  null
  
)

export default component.exports